import { getFlavorCategories } from 'utils/api/flavors.api';
import { useQuery } from 'react-query';

function queryFn({ queryKey }) {
    return getFlavorCategories({
        category: queryKey[1].category,
        country: queryKey[1].country,
        dataSource: queryKey[1].dataSource,
        flavor: queryKey[1].flavor,
        order_by: queryKey[1].order_by,
        ascending: queryKey[1].ascending,
    });
}

export const getQueryKey = ({
    category,
    country,
    dataSource,
    flavor,
    order_by,
    ascending,
}) => {
    return [
        'flavor-categories',
        {
            category,
            country,
            dataSource,
            flavor,
            order_by,
            ascending,
        },
    ];
};

const useFlavorCategories = ({
    category,
    country,
    dataSource,
    flavor,
    order_by,
    ascending,
    enabled = true,
}) => {
    const queryKey = getQueryKey({
        order_by,
        ascending,
        category,
        country,
        dataSource,
        flavor,
    });
    const query = useQuery(queryKey, queryFn, {
        enabled,
        staleTime: Infinity,
    });
    return query;
};

export default useFlavorCategories;
